import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import type { RoleWithPermissions } from '../../../../shared/model-typings';

//  Actual function to fetch roles.
//  Note that this endpoint returns Roles with permissions (for whatever reason).
function fetchRoles() {
  return get<RoleWithPermissions[]>('/api/roles');
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
const queryKey: QueryKey = ['roles'];

/**
 * useRoles is a hook that fetches and returns the role the
 * current user has access to from /api/roles.
 */
export default function useRoles() {
  return useQuery<RoleWithPermissions[]>({
    queryKey,
    queryFn: fetchRoles,
    //  Roles don't change *that* often, so we can cache them for a while to improve performance.
    staleTime: 1000 * 60 * 1, // 1 minute
  });
}
